var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M18 8.667c0 .586-.119 1.146-.356 1.68a4.36 4.36 0 0 1-.962 1.383c-.405.39-.884.699-1.437.927A4.529 4.529 0 0 1 13.5 13h-2.997V9.75h2.812c.17 0 .288-.073.352-.22.053-.17.023-.302-.088-.398L9 4.732l-4.58 4.4c-.11.096-.14.229-.087.398.064.147.182.22.352.22h2.812V13h-3.56c-1.083 0-2.01-.371-2.781-1.113C.386 11.145 0 10.252 0 9.208 0 8.26.322 7.431.967 6.72A3.847 3.847 0 0 1 3.375 5.46v-.042c0-.734.15-1.435.448-2.104a5.462 5.462 0 0 1 1.2-1.726A5.699 5.699 0 0 1 6.816.432 5.649 5.649 0 0 1 9 0c1.371 0 2.577.423 3.617 1.27 1.04.846 1.683 1.907 1.929 3.182.996.22 1.82.723 2.474 1.51.653.788.98 1.689.98 2.705z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#8A8888",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#255EBA",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-6h24v24H-3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadcloud);
export default __webpack_public_path__ + "static/media/uploadcloud.bcc116fb69e0229a1ce6d02e97156b03.svg";
export { ForwardRef as ReactComponent };